import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';

const gravityTextAnchoredDropdownCss = ":host{--gravity-dropdown-prefix-size:var(--gravity-text-anchored-dropdown-prefix-size, 16px)}.gravity-text-anchored-dropdown{align-items:center;background:none;border:0;cursor:pointer;display:inline-flex;padding:0}.gravity-text-anchored-dropdown__icon{margin-left:4px;transition:all 150ms cubic-bezier(0.32, 0, 0.32, 1)}.gravity-text-anchored-dropdown--disabled{cursor:not-allowed}.gravity-text-anchored-dropdown--open .gravity-text-anchored-dropdown__icon{transform:rotate(-180deg)}";
const GravityTextAnchoredDropdownStyle0 = gravityTextAnchoredDropdownCss;

const GravityTextAnchoredDropdown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.dropdownOptionSelected = createEvent(this, "dropdownOptionSelected", 5);
        this.isOpen = createEvent(this, "isOpen", 1);
        this.scrollEnd = createEvent(this, "scrollEnd", 5);
        this.searchChange = createEvent(this, "searchChange", 5);
        this.generateClassNames = bem('gravity-text-anchored-dropdown');
        this.compact = false;
        this.disabled = false;
        this.flipBottom = false;
        this.label = '';
        this.maxHeight = 420;
        this.mode = 'dark';
        this.options = [];
        this.positionStrategy = 'absolute';
        this.queryType = false;
        this.scrollEndOffset = 1;
        this.searchBusy = false;
        this.searchPlaceholder = 'Search';
        this.selected = [];
        this.selectionBehavior = 'single';
        this.size = 'medium';
        this.width = 'auto';
        this.hover = false;
        this.open = false;
    }
    handleSelection(event) {
        this.dropdownOptionSelected.emit(event.detail);
    }
    handleStateChange(event) {
        this.open = event.detail;
        this.isOpen.emit(this.open);
    }
    componentDidLoad() {
        const anchor = this.element.shadowRoot.querySelector('#text-anchored');
        anchor.onmouseenter = () => {
            this.hover = true;
        };
        anchor.onmouseleave = () => {
            this.hover = false;
        };
    }
    render() {
        const disabled = (this.options.length == 0 && this.queryType === 'filter') || this.disabled;
        let color = this.mode == 'dark' ? 'dark-subtle' : 'light-subtle';
        if (disabled) {
            if (this.mode == 'dark') {
                color = 'dark-muted';
            }
            else {
                color = 'light-muted';
            }
        }
        else if (this.hover || this.open) {
            if (this.mode == 'dark') {
                color = 'dark';
            }
            else {
                color = 'light';
            }
        }
        return [
            h("button", { key: '8a7082b307c2aface68fdbfd46d9b6eebd1683ec', id: "text-anchored", class: this.generateClassNames({
                    open: this.open,
                    disabled,
                }), disabled: this.disabled }, h("gravity-text", { key: '86371c00c9dc10725534ae43f7d06ef6cd791096', class: this.generateClassNames('text'), color: color, size: "x-small", weight: "medium" }, this.label), h("gravity-icon", { key: '1edaf84e2dd3c03be6653f12446b240f2e210fa4', class: this.generateClassNames('icon'), size: "xxx-small", color: color, name: "arrow-down" })),
            h("gravity-dropdown", { key: '901547da1c31ee353a3f663ced4c0b4fa002d557', compact: this.compact, disabled: disabled, "flip-bottom": this.flipBottom, for: "text-anchored", maxHeight: this.maxHeight, onDropdownOptionSelected: (event) => this.handleSelection(event), onIsOpen: (event) => this.handleStateChange(event), onScrollEnd: () => this.scrollEnd.emit(), onSearchChange: (event) => this.searchChange.emit(event.detail), options: this.options, "position-strategy": this.positionStrategy, "query-type": this.queryType, "scroll-end-offset": this.scrollEndOffset, searchPlaceholder: this.searchPlaceholder, searchBusy: this.searchBusy, selected: this.selected, "selection-behavior": this.selectionBehavior, size: this.size, width: this.width }),
        ];
    }
    get element() { return getElement(this); }
};
GravityTextAnchoredDropdown.style = GravityTextAnchoredDropdownStyle0;

export { GravityTextAnchoredDropdown as gravity_text_anchored_dropdown };

//# sourceMappingURL=gravity-text-anchored-dropdown.entry.js.map